__turbopack_context__.v({
  "CenterWrapper": "_2ICZiq_CenterWrapper",
  "ClipContainer": "_2ICZiq_ClipContainer",
  "Expanded": "_2ICZiq_Expanded",
  "Highlight": "_2ICZiq_Highlight",
  "ImageWrapper": "_2ICZiq_ImageWrapper",
  "LogoWrapper": "_2ICZiq_LogoWrapper",
  "Root": "_2ICZiq_Root",
  "Text": "_2ICZiq_Text",
  "TextWrapper": "_2ICZiq_TextWrapper",
  "Title": "_2ICZiq_Title",
  "Video": "_2ICZiq_Video",
  "skeleton-loading": "_2ICZiq_skeleton-loading",
});
